import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {UserService} from '@emm/core/services/user.service';

/**
 * Guard that blocks access for users who ONLY have the MMS_AUTHOR role
 * (i.e., they don't have SUPER_ADMIN, ADMIN, or AUTHOR roles)
 */
export const blockMmsAuthorOnlyGuard: CanActivateFn = () => {
    const userService = inject(UserService);
    const router = inject(Router);

    // If user is MMS Author ONLY (without other admin/author roles), block access
    if (userService.isMmsAuthorOnly()) {
        return router.createUrlTree(['/menu']);
    }

    return true;
};
